import React from 'react'
import { Edit, SaveButton, SimpleForm, TextInput, Toolbar } from 'react-admin'

const SaveOnlyToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
)

const CategoryEdit = ({ permissions, ...props }) => {
  const toolbar = !permissions?.includes('delete:categories') ? <SaveOnlyToolbar /> : undefined
  return (
    <Edit {...props}>
      <SimpleForm toolbar={toolbar}>
        <TextInput source="name" resettable />
      </SimpleForm>
    </Edit>
  )
}

export default CategoryEdit
